import jMoment from 'moment-jalaali';
import { FILTER_TYPES } from 'components/FilterPod';

const filters = [
  {
    title: 'محدوده تاریخ',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateRange',
    id: {
      start: null,
      end: null,
    },
    value: {
      start: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(7, 'days'),
      end: jMoment(new Date().setHours(23, 59, 0, 0)),
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
    disableDelete: true,
  },
  {
    title: 'نام و نام‌خانوادگی',
    label: 'نام و نام‌خانوادگی',
    keyName: 'fullName',
    id: 1677,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'تلفن همراه',
    label: 'تلفن همراه',
    keyName: 'phoneNumber',
    id: 1678,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      englishNumber: true,
    },
  },
  {
    title: 'محدوده‌ مبلغ مورد نظر',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    keyName: 'amountRange',
    id: {
      start: 1670,
      end: 1671,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
      },
      end: {
        currency: true,
      },
    },
  },
  {
    // TODO: is the labels true? is it currency?
    title: 'محدوده میزان استفاده شده',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    keyName: 'usedRange',
    id: {
      start: 1672,
      end: 1673,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
      },
      end: {
        currency: true,
      },
    },
  },
  {
    title: 'محدوده میزان مانده',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    keyName: 'remainRange',
    id: {
      start: 1674,
      end: 1675,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
      },
      end: {
        currency: true,
      },
    },
  },
  {
    title: 'شناسه اعتبار',
    label: 'شناسه اعتبار',
    keyName: 'creditId',
    id: 1666,
    value: null,
    filterType: FILTER_TYPES.text,
  },
  {
    title: 'شناسه مشتری',
    label: 'شناسه مشتری',
    keyName: 'userId',
    id: 1676,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      englishNumber: true,
    },
  },
  {
    // TODO: is the oprions currect?
    title: 'براساس وضعیت',
    label: 'براساس وضعیت',
    keyName: 'status',
    id: 1669,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          value: 'فعال',
          label: 'فعال',
        },
        {
          value: 'غیرفعال',
          label: 'غیرفعال',
        },
      ],
    },
  },
  {
    // TODO: is the oprions currect?
    title: 'دوره',
    label: 'دوره',
    keyName: 'period',
    id: 1684,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          value: 'سالانه',
          label: 'سالانه',
        },
        {
          value: 'ماهانه',
          label: 'ماهانه',
        },
        {
          value: 'هفتگی',
          label: 'هفتگی',
        },
        {
          value: 'روزانه',
          label: 'روزانه',
        },
        {
          value: 'بدون دوره',
          label: 'بدون دوره',
        },
      ],
    },
  },
  {
    title: 'تعداد شارژ مجدد',
    label: 'تعداد شارژ مجدد',
    keyName: 'rechargeCount',
    id: 1683,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      englishNumber: true,
    },
  },
  {
    title: 'محدوده‌ زمان شروع',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'startDateRange',
    id: {
      start: 1679,
      end: 1680,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
  },
  {
    title: 'محدوده‌ زمان انقضا',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'expireDateRange',
    id: {
      start: 1681,
      end: 1682,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
  },

  {
    title: 'محدوده‌ زمان ایجاد',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'createDateRange',
    id: {
      start: 1667,
      end: 1668,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
  },
  {
    title: 'جستجو در توضیحات',
    label: 'توضیحات',
    keyName: 'description',
    id: 1685,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
];

export default filters;
